import React, { useState } from 'react';
import axios from 'axios';
import './payment.css'
import PaymentServices from '../services/externalServices/paymentServices_Before_ReddyChanges';
import * as XLSX from 'xlsx'; // At the top of the file, if not already present
import env from "../../env.json";
const { BASE_URL } = env;

const Payment = () => {
  
  const [step, setStep] = useState(1);
  const [transactionFile, setTransactionFile] = useState(null);
  const [settlementFile, setSettlementFile] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const [reportData, setReportData] = useState(null);


  const nextStep = () => setStep(step + 1);
  const prevStep = () => setStep(step - 1);

  const handleTransactionUpload = (e) => {
    setTransactionFile(e.target.files[0]);
  };

  const handleSettlementUpload = (e) => {
    setSettlementFile(e.target.files[0]);
  };














  const processFiles = async () => {
    setIsProcessing(true);
    setProgress(0);
    setError('');
    setSuccess('');

    try {
      // Create FormData for both files
      const formData = new FormData();
      formData.append('transactionFile', transactionFile);
      formData.append('settlementFile', settlementFile);

      // Configure axios for progress tracking
      const config = {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setProgress(percentCompleted);
        },
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };

      // DO NOT set Content-Type manually
      const response = axios.post(`${BASE_URL}/processPaymentFiles`, formData)
      // const response = axios.post('http://localhost:8080/processPaymentFiles', formData)
      // const response = axios.post('https://admin-api.cruze.asia/processPaymentFiles', formData)
        .then(response => console.log('Success:', response))
        .catch(error => console.error('Error:', error));

      // Send to backend
      // const response = await axios.post(
      //   '/api/process-payment-files',
      //   formData,
      //   config
      // );

      // console.log('beofre sending the response', transactionFile, settlementFile);
      // const response = await PaymentServices.uploadPaymentFiles(
      //   transactionFile,
      //   settlementFile,
      //   (progressEvent) => {
      //     const percentCompleted = Math.round(
      //       (progressEvent.loaded * 100) / progressEvent.total
      //     );
      //     setProgress(percentCompleted);
      //   }
      // );

      console.log('After sending the response', response);

      setSuccess('Files processed successfully! Payment confirmation table created.');
      nextStep();
    } catch (err) {
      setError(err.response?.data?.message || 'Error processing files');
    } finally {
      setIsProcessing(false);
    }
  };












  // const generatePayoutFile = (bankName, reportData) => {
  //   if (!reportData || !reportData.summary || !reportData.summary.detailedEntries) {
  //     alert("No report data found.");
  //     return;
  //   }

  //   const data = reportData.summary.detailedEntries;

  //   let formattedData;
  //   let headers;

  //   if (bankName === "ICICI Bank") {
  //     formattedData = data.map((entry) => ({
  //       "Transaction Date": new Date(entry.date || entry.transactionDate).toLocaleDateString(),
  //       "Transaction Ref No": entry.transactionId || "N/A",
  //       "Amount In INR": entry.customerAmount || 0,
  //       "Payment State": entry.status || "N/A",
  //       "Driver Full Name": entry.driverName || "N/A",
  //       "Payment Mode": entry.paymentMode || "N/A",
  //       "UTR Number": entry.utr || "N/A",
  //       "UPI Transaction ID": entry.upiTransactionId || "N/A",
  //       "User ID": entry.userId || "N/A",
  //       "Driver Account Number": entry.accountNumber || "N/A",
  //       "Driver IFSC": entry.ifscCode || "N/A",
  //       "Driver Account Type": entry.accountType || "N/A",
  //       "Merchant ID": entry.merchantId || "N/A",
  //       "Merchant Transaction ID": entry.merchantTransactionId || "N/A",
  //     }));

  //     headers = Object.keys(formattedData[0]);
  //   }

  //   else if (bankName === "Ujjivan Bank") {
  //     formattedData = data.map((entry) => ({
  //       "Identifier": "NFT",
  //       "Unique reference number": entry.transactionId || "N/A",
  //       "Amount": entry.customerAmount || 0,
  //       "Debit Account number": "XXXXXX1234", // Replace with actual if needed
  //       "Beneficiary Name": entry.driverName || "N/A",
  //       "Beneficiary Address": "",
  //       "Beneficiary Account number": entry.accountNumber || "N/A",
  //       "Beneficiary Bank IFSC code": entry.ifscCode || "N/A",
  //       "Remarks": "",
  //       "LEI": "",
  //     }));

  //     headers = Object.keys(formattedData[0]);
  //   }

  //   const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });
  //   const colWidths = headers.map((h) => ({ wch: Math.max(15, h.length + 5) }));
  //   ws["!cols"] = colWidths;

  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, bankName);
  //   XLSX.writeFile(wb, `${bankName.replace(" ", "_")}_Payout_Report.xlsx`);
  // };











  // const generatePayoutFile = (bankName, reportData) => {
  //   if (!reportData || !reportData.summary || !reportData.summary.detailedEntries) {
  //     alert("No report data found.");
  //     return;
  //   }

  //   const data = reportData.summary.detailedEntries;

  //   let formattedData;
  //   let headers;

  //   if (bankName === "ICICI Bank") {
  //     formattedData = data.map((entry) => {
  //       // Common fields for both services
  //       const baseFields = {
  //         "Transaction Date": new Date(entry.date || entry.transactionDate).toLocaleDateString(),
  //         "Transaction Ref No": entry.transactionId || "N/A",
  //         "Amount In INR": entry.customerAmount || 0,
  //         "Payment State": entry.status || "N/A",
  //         "Payment Mode": entry.paymentMode || "N/A",
  //         "UTR Number": entry.utr || "N/A",
  //         "UPI Transaction ID": entry.upiTransactionId || "N/A"
  //       };

  //       // Service-specific fields
  //       if (entry.serviceType === "taxi") {
  //         return {
  //           ...baseFields,
  //           "Driver Full Name": entry.driverName || "N/A",
  //           "User ID": entry.userId || "N/A",
  //           "Driver Account Number": entry.accountNumber || "N/A",
  //           "Driver IFSC": entry.ifscCode || "N/A",
  //           "Driver Account Type": entry.accountType || "N/A",
  //           "Merchant ID": entry.merchantId || "N/A",
  //           "Merchant Transaction ID": entry.merchantTransactionId || "N/A"
  //         };
  //       } else { // theater
  //         return {
  //           ...baseFields,
  //           "Theatre Name": entry.theatreName || "N/A",
  //           "Theatre Base Amount": entry.theatreBaseAmount || 0,
  //           "Theatre GST Amount": entry.theatreGstAmount || 0,
  //           "Beneficiary Name": entry.beneficiaryName || "N/A",
  //           "Beneficiary Account": entry.accountNumber || "N/A",
  //           "Beneficiary IFSC": entry.ifscCode || "N/A",
  //           "Beneficiary Bank": entry.bankName || "N/A"
  //         };
  //       }
  //     });

  //     headers = Object.keys(formattedData[0]);
  //   }
  //   else if (bankName === "Ujjivan Bank") {
  //     formattedData = data.map((entry) => {
  //       const baseFields = {
  //         "Identifier": "NFT",
  //         "Unique reference number": entry.transactionId || "N/A",
  //         "Amount": entry.customerAmount || 0,
  //         "Debit Account number": "XXXXXX1234", // Replace with actual if needed
  //         "Remarks": "",
  //         "LEI": ""
  //       };

  //       if (entry.serviceType === "taxi") {
  //         return {
  //           ...baseFields,
  //           "Beneficiary Name": entry.driverName || "N/A",
  //           "Beneficiary Address": "",
  //           "Beneficiary Account number": entry.accountNumber || "N/A",
  //           "Beneficiary Bank IFSC code": entry.ifscCode || "N/A"
  //         };
  //       } else { // theater
  //         return {
  //           ...baseFields,
  //           "Beneficiary Name": entry.beneficiaryName || "N/A",
  //           "Beneficiary Address": entry.theatreAddress || "",
  //           "Beneficiary Account number": entry.accountNumber || "N/A",
  //           "Beneficiary Bank IFSC code": entry.ifscCode || "N/A",
  //           "Beneficiary Bank Name": entry.bankName || "N/A"
  //         };
  //       }
  //     });

  //     headers = Object.keys(formattedData[0]);
  //   }

  //   // Create worksheet with proper column widths
  //   const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });

  //   // Calculate column widths
  //   const colWidths = headers.map(header => {
  //     let maxLength = header.length;
  //     formattedData.forEach(row => {
  //       const cellValue = row[header] !== undefined ? String(row[header]) : '';
  //       if (cellValue.length > maxLength) {
  //         maxLength = cellValue.length;
  //       }
  //     });
  //     return { wch: Math.min(Math.max(maxLength, 10), 50) }; // Min width 10, max 50
  //   });
  //   ws["!cols"] = colWidths;

  //   // Create workbook and save
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, bankName.replace(" ", "_"));

  //   // Add timestamp to filename
  //   const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
  //   XLSX.writeFile(wb, `${bankName.replace(" ", "_")}_Payout_${timestamp}.xlsx`);
  // };







  const generatePayoutFile = (bankName, reportData) => {
    if (!reportData || !reportData.summary || !reportData.summary.detailedEntries) {
      alert("No report data found.");
      return;
    }

    const data = reportData.summary.detailedEntries;

    let formattedData;
    let headers;

    if (bankName === "ICICI Bank") {
      formattedData = data.map((entry) => {
        const bankDetails = entry.serviceType === "taxi" ? entry.riderBankDetails : entry.theaterBankDetails || {};

        const baseFields = {
          "Transaction Date": new Date(entry.transactionDate || reportData.generatedAt).toLocaleDateString(),
          "Transaction Ref No": entry.transactionId || "N/A",
          "Amount In INR": entry.customerAmount || 0,
          "Payment State": entry.status || "N/A",
          "Payment Mode": entry.paymentMode || "N/A",
          "UTR Number": entry.utr || "N/A",
          "UPI Transaction ID": bankDetails.UPIId || "N/A"
        };

        if (entry.serviceType === "taxi") {
          return {
            ...baseFields,
            "Driver Full Name": bankDetails.accountHolderName || "N/A",
            "User ID": entry.userId || "N/A",
            "Driver Account Number": bankDetails.accountNumber || "N/A",
            "Driver IFSC": bankDetails.IFSC || "N/A",
            "Driver Account Type": bankDetails.accountType || "N/A",
            "Merchant ID": entry.merchantId || "N/A",
            "Merchant Transaction ID": entry.merchantTransactionId || "N/A"
          };
        } else { // theater
          return {
            ...baseFields,
            "Theatre Name": entry.theatreName || "N/A",
            "Theatre Base Amount": entry.theatreBaseAmount || 0,
            "Theatre GST Amount": entry.theatreGstAmount || 0,
            "Beneficiary Name": bankDetails.beneficiaryName || "N/A",
            "Beneficiary Account": bankDetails.accountNumber || "N/A",
            "Beneficiary IFSC": bankDetails.ifscCode || bankDetails.IFSC || "N/A",
            "Beneficiary Bank": bankDetails.bankName || "N/A"
          };
        }
      });

      headers = Object.keys(formattedData[0]);
    }
    else if (bankName === "Ujjivan Bank") {
      formattedData = data.map((entry) => {
        const bankDetails = entry.serviceType === "taxi" ? entry.riderBankDetails : entry.theaterBankDetails || {};

        const baseFields = {
          "Identifier": "NFT",
          "Unique reference number": entry.transactionId || "N/A",
          "Amount": entry.customerAmount || 0,
          "Debit Account number": "XXXXXX1234", // Replace if needed
          "Remarks": "",
          "LEI": ""
        };

        if (entry.serviceType === "taxi") {
          return {
            ...baseFields,
            "Beneficiary Name": bankDetails.accountHolderName || "N/A",
            "Beneficiary Address": "",
            "Beneficiary Account number": bankDetails.accountNumber || "N/A",
            "Beneficiary Bank IFSC code": bankDetails.IFSC || "N/A"
          };
        } else { // theater
          return {
            ...baseFields,
            "Beneficiary Name": bankDetails.beneficiaryName || "N/A",
            "Beneficiary Address": bankDetails.branchName || "",
            "Beneficiary Account number": bankDetails.accountNumber || "N/A",
            "Beneficiary Bank IFSC code": bankDetails.ifscCode || bankDetails.IFSC || "N/A",
            "Beneficiary Bank Name": bankDetails.bankName || "N/A"
          };
        }
      });

      headers = Object.keys(formattedData[0]);
    }

    // Create worksheet with proper column widths
    const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });

    // Calculate column widths
    const colWidths = headers.map(header => {
      let maxLength = header.length;
      formattedData.forEach(row => {
        const cellValue = row[header] !== undefined ? String(row[header]) : '';
        if (cellValue.length > maxLength) {
          maxLength = cellValue.length;
        }
      });
      return { wch: Math.min(Math.max(maxLength, 10), 50) }; // Min width 10, max 50
    });
    ws["!cols"] = colWidths;

    // Create workbook and save
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, bankName.replace(" ", "_"));

    // Add timestamp to filename
    const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
    XLSX.writeFile(wb, `${bankName.replace(" ", "_")}_Payout_${timestamp}.xlsx`);
  };


  return (
    <div className="container mx-auto p-4 max-w-3xl">
      <h1 className="text-2xl font-bold mb-6">Payment File Processing Wizard</h1>

      {/* Progress Steps */}
      <div className="flex mb-8">
        <div className={`step ${step >= 1 ? 'active' : ''}`}>
          <div className="step-number">1</div>
          <div className="step-title">Upload Files</div>
        </div>
        <div className={`step ${step >= 2 ? 'active' : ''}`}>
          <div className="step-number">2</div>
          <div className="step-title">Process Files</div>
        </div>
        <div className={`step ${step >= 3 ? 'active' : ''}`}>
          <div className="step-number">3</div>
          <div className="step-title">Confirmation</div>
        </div>

        <div className={`step ${step >= 4 ? 'active' : ''}`}>
          <div className="step-number">4</div>
          <div className="step-title">Select the Bank to Pay</div>
        </div>
      </div>

      {/* Step Content */}
      <div className="bg-white p-6 rounded-lg shadow-md">
        {step === 1 && (
          <Step1
            transactionFile={transactionFile}
            settlementFile={settlementFile}
            onTransactionUpload={handleTransactionUpload}
            onSettlementUpload={handleSettlementUpload}
            onNext={nextStep}
          />
        )}

        {step === 2 && (
          <Step2
            onProcess={processFiles}
            onBack={prevStep}
            isProcessing={isProcessing}
            progress={progress}
            error={error}
          />
        )}
        {/* 
        {step === 3 && (
          <Step3
            success={success}
          />
        )}



        {step === 4 && (
          <Step4 onBack={prevStep} />
        )} */}







        {step === 3 && (
          <Step3
            success={success}
            setReportData={setReportData}
            nextStep={nextStep}
          />
        )}

        {step === 4 && (
          <Step4
            onBack={prevStep}
            reportData={reportData}
            generatePayoutFile={generatePayoutFile} // ✅ add this
          />
        )}





      </div>
    </div>
  );
};

// Step Components
const Step1 = ({ transactionFile, settlementFile, onTransactionUpload, onSettlementUpload, onNext }) => {
  const canProceed = transactionFile && settlementFile;

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Step 1: Upload Files</h2>

      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Transaction File
        </label>
        <div className="flex items-center">
          <input
            type="file"
            onChange={onTransactionUpload}
            className="block w-full text-sm text-gray-500
              file:mr-4 file:py-2 file:px-4
              file:rounded-md file:border-0
              file:text-sm file:font-semibold
              file:bg-blue-50 file:text-blue-700
              hover:file:bg-blue-100"
          />
        </div>
        {transactionFile && (
          <p className="mt-2 text-sm text-gray-600">
            Selected: {transactionFile.name}
          </p>
        )}
      </div>

      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Settlement File
        </label>
        <div className="flex items-center">
          <input
            type="file"
            onChange={onSettlementUpload}
            className="block w-full text-sm text-gray-500
              file:mr-4 file:py-2 file:px-4
              file:rounded-md file:border-0
              file:text-sm file:font-semibold
              file:bg-blue-50 file:text-blue-700
              hover:file:bg-blue-100"
          />
        </div>
        {settlementFile && (
          <p className="mt-2 text-sm text-gray-600">
            Selected: {settlementFile.name}
          </p>
        )}
      </div>

      <div className="flex justify-end">
        <button
          onClick={onNext}
          disabled={!canProceed}
          className={`px-4 py-2 rounded-md text-white ${canProceed ? 'bg-blue-600 hover:bg-blue-700' : 'bg-gray-400 cursor-not-allowed'}`}
        >
          Next
        </button>
      </div>
    </div>
  );
};

const Step2 = ({ onProcess, onBack, isProcessing, progress, error }) => {
  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Step 2: Process Files</h2>

      <p className="mb-6 text-gray-700">
        We will now process the uploaded files. This will:
      </p>
      <ul className="mb-6 list-disc pl-5 text-gray-700">
        <li>Store both files in the database</li>
        <li>Extract transaction data</li>
        <li>Create a new Payment Settlement Confirmation table</li>
        <li>Combine transaction, payment confirmation, and settlement data</li>
      </ul>

      {error && (
        <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-md">
          {error}
        </div>
      )}

      {isProcessing && (
        <div className="mb-6">
          <div className="w-full bg-gray-200 rounded-full h-2.5">
            <div
              className="bg-blue-600 h-2.5 rounded-full"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <p className="mt-2 text-sm text-gray-600">
            Processing... {progress}%
          </p>
        </div>
      )}

      <div className="flex justify-between">
        <button
          onClick={onBack}
          className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400"
        >
          Back
        </button>
        <button
          onClick={onProcess}
          disabled={isProcessing}
          className={`px-4 py-2 rounded-md text-white ${isProcessing ? 'bg-blue-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'}`}
        >
          {isProcessing ? 'Processing...' : 'Process Files'}
        </button>
      </div>
    </div>
  );
};


const Step3 = ({ success, nextStep, setReportData }) => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [reportType, setReportType] = useState('all');
  const [isGenerating, setIsGenerating] = useState(false);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const [error, setError] = useState('');
  const [reportGenerated, setReportGenerated] = useState(false);
  const [localReportData, setLocalReportData] = useState(null);

  const [showMatchedOnly, setShowMatchedOnly] = useState(false);






  // For matched entries

  // Filter transactions based on toggle
  const filteredEntries = showMatchedOnly
    ? localReportData?.summary?.detailedEntries.filter(entry => entry.status === 'Matched')
    : localReportData?.summary?.detailedEntries;

  // Calculate matched-only totals
  const matchedTotals = localReportData?.summary?.detailedEntries
    .filter(entry => entry.status === 'Matched')
    .reduce((acc, entry) => ({
      totalCollections: acc.totalCollections + entry.customerAmount,
      totalPayable: acc.totalPayable + entry.payableToPartner,
      platformEarnings: acc.platformEarnings + entry.platformEarnings,
      gatewayCharges: acc.gatewayCharges + entry.gatewayCharges,
      taxes: acc.taxes + entry.taxes,
      count: acc.count + 1
    }), {
      totalCollections: 0,
      totalPayable: 0,
      platformEarnings: 0,
      gatewayCharges: 0,
      taxes: 0,
      count: 0
    });


  // Sample data structure that includes both Taxi and Theater
  // const sampleReportData = {
  //   _id: "rep_123456",
  //   generatedAt: new Date().toISOString(),
  //   periodStart: "2023-01-01",
  //   periodEnd: "2023-01-31",
  //   reportType: "all",
  //   summary: {
  //     totalCollections: 125000,
  //     totalPayableToPartners: 100000,
  //     totalPlatformEarnings: 25000,
  //     netPayableToPlatform: 25000,
  //     totalGatewayCharges: 5000,
  //     totalTaxes: 7000,
  //     serviceWiseBreakdown: {
  //       taxi: {
  //         count: 150,
  //         totalAmount: 75000,
  //         payableToDriver: 60000,
  //         platformEarnings: 15000
  //       },
  //       theater: {
  //         count: 100,
  //         totalAmount: 50000,
  //         payableToTheater: 40000,
  //         platformEarnings: 10000
  //       }
  //     },
  //     detailedEntries: [
  //       // Taxi entries
  //       {
  //         serviceType: "taxi",
  //         transactionId: "txn_001",
  //         customerAmount: 500,
  //         payableToPartner: 400,
  //         platformEarnings: 100,
  //         taxes: 50,
  //         status: "Matched",
  //         date: "2023-01-15"
  //       },
  //       // Theater entries
  //       {
  //         serviceType: "theater",
  //         transactionId: "tkt_001",
  //         customerAmount: 1000,
  //         payableToPartner: 800,
  //         platformEarnings: 200,
  //         taxes: 100,
  //         status: "Matched",
  //         date: "2023-01-10"
  //       },
  //       // More entries...
  //     ]
  //   }
  // };

  const generateReport = async () => {
    if (!fromDate || !toDate) {
      setError('Please select both date ranges');
      return;
    }

    setIsGenerating(true);
    setError('');

    try {
      // Simulating API call with sample data
      // In real implementation, you would use:
      // const response = await axios.post('http://localhost:8080/generateReport', { fromDate, toDate, reportType });
      // setReportData(response.data);
      console.log('before sending a data', fromDate, toDate, reportType)


      const response = await axios.post(`${BASE_URL}/generateReport`, {
      // const response = await axios.post('http://localhost:8080/generateReport', {
      // const response = await axios.post('https://admin-api.cruze.asia/generateReport', {
        fromDate,
        toDate,
        reportType
      });

      console.log('response===================================', response);

      // setReportData(response.data.report);

      console.log('respone data', response?.data?.report)
      // Using sample data for demonstration
      setReportData(response.data.report);
      setLocalReportData(response.data.report);
      setReportGenerated(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to generate report');
    } finally {
      setIsGenerating(false);
    }
  };

  const generatePDF = async () => {
    setIsGeneratingPDF(true);
    try {
      // PDF generation logic
      alert("PDF generation would happen here in real implementation");
    } catch (err) {
      setError('Failed to generate PDF');
    } finally {
      setIsGeneratingPDF(false);
    }
  };

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Step 3: Processing Complete</h2>

      {success && (
        <div className="mb-6 p-4 bg-green-100 text-green-700 rounded-md">
          {success}
        </div>
      )}

      {!reportGenerated ? (
        <div className="bg-gray-50 p-4 rounded-md mb-6">
          <h3 className="font-medium mb-4">Generate Settlement Report</h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">From Date</label>
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="w-full p-2 border rounded-md"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">To Date</label>
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                className="w-full p-2 border rounded-md"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Report Type</label>
              <select
                value={reportType}
                onChange={(e) => setReportType(e.target.value)}
                className="w-full p-2 border rounded-md"
              >
                <option value="all">All Services</option>
                <option value="taxi">Taxi Services</option>
                <option value="theater">Theater Services</option>
              </select>
            </div>
          </div>

          <div className="flex justify-end">
            <button
              onClick={generateReport}
              disabled={isGenerating}
              className={`px-4 py-2 rounded-md text-white ${isGenerating ? 'bg-blue-400' : 'bg-blue-600 hover:bg-blue-700'}`}
            >
              {isGenerating ? 'Generating Report...' : 'Generate Report'}
            </button>
          </div>

          {error && (
            <div className="mt-4 p-3 bg-red-100 text-red-700 rounded-md">
              {error}
            </div>
          )}
        </div>
      ) : (
        <div className="mb-6 space-y-6">
          {/* Report Header */}
          <div className="bg-white p-4 rounded-lg shadow-sm border">
            <h3 className="text-xl font-semibold mb-2">Settlement Report</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <p className="text-sm text-gray-500">Report ID</p>
                <p className="font-medium">{localReportData._id}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Generated At</p>
                <p className="font-medium">
                  {new Date(localReportData.generatedAt).toLocaleString()}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Report Type</p>
                <p className="font-medium capitalize">{localReportData.reportType}</p>
              </div>
            </div>
          </div>

          {/* Period Information */}
          <div className="bg-white p-4 rounded-lg shadow-sm border">
            <h4 className="font-semibold mb-3">Report Period</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <p className="text-sm text-gray-500">Start Date</p>
                <p className="font-medium">
                  {new Date(localReportData.periodStart).toLocaleDateString()}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500">End Date</p>
                <p className="font-medium">
                  {new Date(localReportData.periodEnd).toLocaleDateString()}
                </p>
              </div>
            </div>
          </div>

          {/* Summary Statistics */}



     

          <div className="bg-white p-4 rounded-lg shadow-sm border">
            <h4 className="font-semibold mb-3">Financial Summary</h4>

            {/* Top Row - Transaction Overview */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div className="border p-3 rounded-lg bg-blue-50">
                <h5 className="font-medium mb-2 text-blue-800">All Transactions</h5>
                <div className="space-y-1">
                  <p className="flex justify-between">
                    <span>Total Transactions:</span>
                    <span>{localReportData.summary.detailedEntries.length}</span>
                  </p>
                  <p className="flex justify-between">
                    <span>Total Collections:</span>
                    <span>₹{localReportData.summary.totalCollections.toFixed(2)}</span>
                  </p>
                </div>
              </div>

              <div className="border p-3 rounded-lg bg-green-50">
                <h5 className="font-medium mb-2 text-green-800">Matched (Payable)</h5>
                <div className="space-y-1">
                  <p className="flex justify-between">
                    <span>Matched Transactions:</span>
                    <span>{matchedTotals.count}</span>
                  </p>
                  <p className="flex justify-between">
                    <span>Total Amount (Matched):</span>
                    <span>₹{matchedTotals.totalCollections.toFixed(2)}</span>
                  </p>
                  <p className="flex justify-between">
                    <span>Payable Amount:</span>
                    <span>₹{matchedTotals.totalPayable.toFixed(2)}</span>
                  </p>
                  <p className="flex justify-between">
                    <span>Platform Earnings:</span>
                    <span>₹{matchedTotals.platformEarnings.toFixed(2)}</span>
                  </p>
                </div>
              </div>
            </div>

            {/* Bottom Row - Financial Details */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {/* Gateway Charges */}
              <div className="border p-3 rounded-lg">
                <p className="text-sm text-gray-500">Gateway Charges</p>
                <div className="mt-2 space-y-1">
                  <p className="flex justify-between text-sm">
                    <span>All Transactions:</span>
                    <span>₹{localReportData.summary.totalGatewayCharges.toFixed(2)}</span>
                  </p>
                  <p className="flex justify-between font-medium">
                    <span className="text-green-600">Matched Only:</span>
                    <span className="text-green-600">₹{matchedTotals.gatewayCharges.toFixed(2)}</span>
                  </p>
                </div>
              </div>

              {/* Taxes */}
              <div className="border p-3 rounded-lg">
                <p className="text-sm text-gray-500">Taxes</p>
                <div className="mt-2 space-y-1">
                  <p className="flex justify-between text-sm">
                    <span>All Transactions:</span>
                    <span>₹{localReportData.summary.totalTaxes.toFixed(2)}</span>
                  </p>
                  <p className="flex justify-between font-medium">
                    <span className="text-green-600">Matched Only:</span>
                    <span className="text-green-600">₹{matchedTotals.taxes.toFixed(2)}</span>
                  </p>
                </div>
              </div>

              {/* Net Payable */}
              <div className="border p-3 rounded-lg">
                <p className="text-sm text-gray-500">Net Payable to Platform</p>
                <div className="mt-2 space-y-1">
                  <p className="flex justify-between text-sm">
                    <span>All Transactions:</span>
                    <span>₹{(localReportData.summary.totalPlatformEarnings - localReportData.summary.totalGatewayCharges).toFixed(2)}</span>
                  </p>
                  <p className="flex justify-between font-medium">
                    <span className="text-green-600">Matched Only:</span>
                    <span className="text-green-600">
                      ₹{(matchedTotals.platformEarnings - matchedTotals.gatewayCharges).toFixed(2)}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Transaction Filter Toggle */}
          {/* <div className="flex justify-end">
            <label className="inline-flex items-center cursor-pointer">
              <span className="mr-3 text-sm font-medium text-gray-700">
                Show matched only
              </span>
              <div className="relative">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={showMatchedOnly}
                  onChange={() => setShowMatchedOnly(!showMatchedOnly)}
                />
                <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
              </div>
            </label>
          </div> */}






          {/* Service-wise Breakdown */}
          {/* Service-wise Breakdown */}
          <div className="bg-white p-4 rounded-lg shadow-sm border">
            <h4 className="font-semibold mb-3">Service Breakdown</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Theater Service */}
              <div className="border p-3 rounded-lg">
                <h5 className="font-medium mb-2">Theater Services</h5>
                <div className="space-y-2">
                  {/* All Transactions */}
                  <div className="pb-2 border-b">
                    <p className="text-sm text-gray-500">All Transactions</p>
                    <p className="flex justify-between">
                      <span>Total Transactions:</span>
                      <span>{localReportData.summary.serviceWiseBreakdown.theater.count}</span>
                    </p>
                    <p className="flex justify-between">
                      <span>Total Amount:</span>
                      <span>₹{localReportData.summary.serviceWiseBreakdown.theater.totalAmount.toFixed(2)}</span>
                    </p>
                  </div>

                  {/* Matched Only */}
                  <div className="pt-2">
                    <p className="text-sm text-green-600">Matched (Payable)</p>
                    <p className="flex justify-between">
                      <span>Matched Count:</span>
                      <span className="text-green-600">
                        {localReportData.summary.detailedEntries.filter(e =>
                          e.serviceType === 'theater' && e.status === 'Matched'
                        ).length}
                      </span>
                    </p>
                    <p className="flex justify-between">
                      <span>Payable Amount:</span>
                      <span className="font-semibold text-green-600">
                        ₹{localReportData.summary.detailedEntries
                          .filter(e => e.serviceType === 'theater' && e.status === 'Matched')
                          .reduce((sum, e) => sum + e.payableToPartner, 0)
                          .toFixed(2)}
                      </span>
                    </p>
                    <p className="flex justify-between">
                      <span>Platform Earnings:</span>
                      <span>
                        ₹{localReportData.summary.detailedEntries
                          .filter(e => e.serviceType === 'theater' && e.status === 'Matched')
                          .reduce((sum, e) => sum + e.platformEarnings, 0)
                          .toFixed(2)}
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              {/* Taxi Service */}
              <div className="border p-3 rounded-lg">
                <h5 className="font-medium mb-2">Taxi Services</h5>
                <div className="space-y-2">
                  {/* All Transactions */}
                  <div className="pb-2 border-b">
                    <p className="text-sm text-gray-500">All Transactions</p>
                    <p className="flex justify-between">
                      <span>Total Transactions:</span>
                      <span>{localReportData.summary.serviceWiseBreakdown.taxi.count}</span>
                    </p>
                    <p className="flex justify-between">
                      <span>Total Amount:</span>
                      <span>₹{localReportData.summary.serviceWiseBreakdown.taxi.totalAmount.toFixed(2)}</span>
                    </p>
                  </div>

                  {/* Matched Only */}
                  <div className="pt-2">
                    <p className="text-sm text-green-600">Matched (Payable)</p>
                    <p className="flex justify-between">
                      <span>Matched Count:</span>
                      <span className="text-green-600">
                        {localReportData.summary.detailedEntries.filter(e =>
                          e.serviceType === 'taxi' && e.status === 'Matched'
                        ).length}
                      </span>
                    </p>
                    <p className="flex justify-between">
                      <span>Payable Amount:</span>
                      <span className="font-semibold text-green-600">
                        ₹{localReportData.summary.detailedEntries
                          .filter(e => e.serviceType === 'taxi' && e.status === 'Matched')
                          .reduce((sum, e) => sum + e.payableToPartner, 0)
                          .toFixed(2)}
                      </span>
                    </p>
                    <p className="flex justify-between">
                      <span>Platform Earnings:</span>
                      <span>
                        ₹{localReportData.summary.detailedEntries
                          .filter(e => e.serviceType === 'taxi' && e.status === 'Matched')
                          .reduce((sum, e) => sum + e.platformEarnings, 0)
                          .toFixed(2)}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Detailed Transactions */}
          {/* <div className="bg-white p-4 rounded-lg shadow-sm border">
            <div className="flex justify-between items-center mb-3">
              <h4 className="font-semibold">Detailed Transactions</h4>
              <span className="text-sm text-gray-500">
                {localReportData.summary.detailedEntries.length} transactions
              </span>
            </div>

            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Service</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Transaction</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Payable</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Earnings</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Taxes</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {localReportData.summary.detailedEntries.map((entry, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-4 py-3 whitespace-nowrap">
                        <span className={`px-2 py-1 text-xs rounded-full ${
                          entry.serviceType === 'taxi' ? 'bg-blue-100 text-blue-800' : 'bg-purple-100 text-purple-800'
                        }`}>
                          {entry.serviceType}
                        </span>
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        {entry.transactionId || 'N/A'}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        ₹{entry.customerAmount.toFixed(2)}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        ₹{entry.payableToPartner.toFixed(2)}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        ₹{entry.platformEarnings.toFixed(2)}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        ₹{entry.taxes.toFixed(2)}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        <span className={`px-2 py-1 text-xs rounded-full ${
                          entry.status === 'Matched' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
                        }`}>
                          {entry.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div> */}


          {/* Detailed Transactions */}
          <div className="bg-white p-4 rounded-lg shadow-sm border">
            <div className="flex justify-between items-center mb-3">
              <h4 className="font-semibold">Detailed Transactions</h4>
              <span className="text-sm text-gray-500">
                {localReportData.summary.detailedEntries.length} transactions
              </span>
            </div>

            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Service</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Invoice</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Transaction</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total Payable</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Base Amount</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Taxes on Base Amount</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Gateway Charges</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Platform Fee Collection</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Platform Tax</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Bank Details</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {localReportData.summary.detailedEntries.map((entry, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-4 py-3 whitespace-nowrap">
                        <span className={`px-2 py-1 text-xs rounded-full ${entry.serviceType === 'taxi' ? 'bg-blue-100 text-blue-800' : 'bg-purple-100 text-purple-800'
                          }`}>
                          {entry.serviceType}
                        </span>
                      </td>


                      <td className="px-4 py-3 whitespace-nowrap">
                        {entry.invoiceNumber || 'N/A'}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        {entry.transactionId || 'N/A'}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        ₹{entry?.customerAmount?.toFixed(2)}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        ₹{entry?.payableToPartner?.toFixed(2)}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        ₹{entry?.baseAmount?.toFixed(2)}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        ₹{entry?.taxes?.toFixed(2)}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        ₹{entry?.gatewayCharges?.toFixed(2)}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        ₹{entry?.platformEarnings?.toFixed(2)}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        ₹{entry?.platformTax?.toFixed(2)}
                      </td>

                      <td className="px-4 py-3 whitespace-nowrap">
                        <span className={`px-2 py-1 text-xs rounded-full ${entry.status === 'Matched' ? 'bg-green-100 text-green-800' :
                          entry.status === 'NA' ? 'bg-gray-100 text-gray-800' : 'bg-yellow-100 text-yellow-800'
                          }`}>
                          {entry?.status}
                        </span>
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        {entry.serviceType === 'taxi' && entry.riderBankDetails ? (
                          <div className="text-xs">
                            <p><strong>Bank:</strong> {entry.riderBankDetails.bankName}</p>
                            <p><strong>Account:</strong> {entry.riderBankDetails.accountNumber}</p>
                            <p><strong>IFSC:</strong> {entry.riderBankDetails.IFSC}</p>
                          </div>
                        ) : entry.serviceType === 'theater' && entry.theaterBankDetails ? (
                          <div className="text-xs">
                            <p><strong>Bank:</strong> {entry.theaterBankDetails.bankName}</p>
                            <p><strong>Account:</strong> {entry.theaterBankDetails.accountNumber}</p>
                            <p><strong>IFSC:</strong> {entry.theaterBankDetails.ifscCode}</p>
                          </div>
                        ) : 'N/A'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-between">
            <div>
              <button
                onClick={generatePDF}
                disabled={isGeneratingPDF}
                className={`px-4 py-2 rounded-md text-white flex items-center ${isGeneratingPDF ? 'bg-gray-400' : 'bg-green-600 hover:bg-green-700'
                  }`}
              >
                {isGeneratingPDF ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Generating PDF...
                  </>
                ) : (
                  <>
                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"></path>
                    </svg>
                    Download PDF Report
                  </>
                )}
              </button>
            </div>
            <div>
              <button
                onClick={() => setReportGenerated(false)}
                className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400 mr-4"
              >
                Regenerate Report
              </button>
              <button
                onClick={nextStep}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                Next: Select Bank for Payout
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};



// const Step4 = ({ onBack, reportData, generatePayoutFile }) => {
//   const [selectedBank, setSelectedBank] = useState('Ujjivan Bank'); // Default to Ujjivan Bank
//   const [isGenerating, setIsGenerating] = useState(false);

//   // Calculate totals only for Matched entries
//   const matchedEntries = reportData?.summary?.detailedEntries?.filter(entry => entry.status === 'Matched') || [];

//   const totalPayable = matchedEntries.reduce((sum, entry) => sum + entry.payableToPartner, 0);
//   const numberOfBeneficiaries = matchedEntries.length;


//   // New calculations for receipt
//   const totalCollected = matchedEntries.reduce((sum, entry) => sum + entry.customerAmount, 0);
//   // const totalCommission = totalCollected - totalPayable;



//     // Calculate detailed breakdown
//     const totalPlatformFee = matchedEntries.reduce((sum, entry) => sum + (entry.platformFee || 0), 0);
//     const totalGST = matchedEntries.reduce((sum, entry) => sum + (entry.gstOnPlatformFee || 0), 0);
//     const totalGatewayCharges = matchedEntries.reduce((sum, entry) => sum + (entry.gatewayCharges || 0), 0);
//     const totalCommission = totalCollected - totalPayable;

//     // Function to handle receipt download
//     const downloadReceipt = () => {
//       // Create a HTML string for the receipt
//       const receiptHTML = `
//         <html>
//           <head>
//             <title>Payment Receipt</title>
//             <style>
//               body { font-family: Arial, sans-serif; margin: 20px; }
//               .receipt { max-width: 500px; margin: 0 auto; border: 1px solid #ddd; padding: 20px; }
//               .header { text-align: center; margin-bottom: 20px; }
//               .summary { margin-bottom: 20px; }
//               .row { display: flex; justify-content: space-between; margin-bottom: 8px; }
//               .total-row { border-top: 1px solid #000; padding-top: 10px; margin-top: 10px; font-weight: bold; }
//               .section-title { font-weight: bold; margin: 15px 0 5px 0; }
//               .negative { color: #e53e3e; }
//             </style>
//           </head>
//           <body>
//             <div class="receipt">
//               <div class="header">
//                 <h2>Payment Receipt</h2>
//                 <p>Date: ${new Date().toLocaleDateString()}</p>
//               </div>

//               <div class="summary">
//                 <div class="row">
//                   <span>Total Collected from Customers:</span>
//                   <span>₹${totalCollected.toFixed(2)}</span>
//                 </div>

//                 <div class="section-title">Deductions:</div>

//                 <div class="row">
//                   <span>Platform Fee:</span>
//                   <span class="negative">- ₹${totalPlatformFee.toFixed(2)}</span>
//                 </div>

//                 <div class="row">
//                   <span>GST on Platform Fee (18%):</span>
//                   <span class="negative">- ₹${totalGST.toFixed(2)}</span>
//                 </div>

//                 <div class="row">
//                   <span>Payment Gateway Charges:</span>
//                   <span class="negative">- ₹${totalGatewayCharges.toFixed(2)}</span>
//                 </div>

//                 <div class="row total-row">
//                   <span>Net Payable to Partners:</span>
//                   <span>₹${totalPayable.toFixed(2)}</span>
//                 </div>

//                 <div class="row">
//                   <span>Number of Beneficiaries:</span>
//                   <span>${numberOfBeneficiaries}</span>
//                 </div>
//               </div>
//             </div>
//           </body>
//         </html>
//       `;

//       // Create a blob and download it
//       const blob = new Blob([receiptHTML], { type: 'text/html' });
//       const url = URL.createObjectURL(blob);
//       const a = document.createElement('a');
//       a.href = url;
//       a.download = `payment_receipt_${new Date().toISOString().split('T')[0]}.html`;
//       document.body.appendChild(a);
//       a.click();
//       document.body.removeChild(a);
//       URL.revokeObjectURL(url);
//     };

//   const handleGenerate = () => {
//     if (!selectedBank) {
//       alert("Please select a bank.");
//       return;
//     }
//     setIsGenerating(true);

//     // Only pass matched entries for payout file generation
//     const payoutData = {
//       ...reportData,
//       summary: {
//         ...reportData.summary,
//         detailedEntries: matchedEntries
//       }
//     };

//     generatePayoutFile(selectedBank, payoutData);
//     setIsGenerating(false);
//   };

//   return (
//     <div>
//       <h2 className="text-xl font-semibold mb-4">Step 4: Select the Bank to Pay</h2>

//       <div className="mb-6 bg-gray-50 p-4 rounded-md">
//         <h3 className="font-medium mb-2">Payout Summary (Matched Entries Only)</h3>





//  {/* New Receipt Section */}
//  <div className="mb-6 bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
//           <h4 className="text-lg font-medium mb-3 text-center">Payment Receipt</h4>
//           <div className="space-y-3">
//             <div className="flex justify-between border-b pb-2">
//               <span className="font-medium">Total Collected from Customers</span>
//               <span className="font-mono">+ ₹{totalCollected.toFixed(2)}</span>
//             </div>

//             <div className="flex justify-between border-b pb-2">
//               <div>
//                 <span className="font-medium">Commission & Deductions</span>
//                 <p className="text-xs text-gray-500 mt-1">(Platform fee, GST, etc.)</p>
//               </div>
//               <span className="font-mono text-red-600">- ₹{totalCommission.toFixed(2)}</span>
//             </div>

//             <div className="flex justify-between pt-3 border-t-2 border-gray-300">
//               <span className="font-bold">Net Payable to Partners</span>
//               <span className="font-bold font-mono">₹{totalPayable.toFixed(2)}</span>
//             </div>
//           </div>
//         </div>
//         {/* End Receipt Section */}







//          {/* Enhanced Receipt Section */}
//          <div className="mb-6 bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
//           <div className="flex justify-between items-center mb-4">
//             <h4 className="text-lg font-medium">Payment Receipt</h4>
//             <button 
//               onClick={downloadReceipt}
//               className="px-3 py-1 bg-blue-100 text-blue-700 rounded-md text-sm hover:bg-blue-200"
//             >
//               Download Receipt
//             </button>
//           </div>

//           <div className="space-y-3">
//             <div className="flex justify-between border-b pb-2">
//               <span className="font-medium">Total Collected from Customers</span>
//               <span className="font-mono">+ ₹{totalCollected.toFixed(2)}</span>
//             </div>

//             <div className="mt-3">
//               <h5 className="font-medium text-gray-700 mb-2">Deductions:</h5>
//               <div className="space-y-2 pl-4">
//                 <div className="flex justify-between">
//                   <div className="flex items-center">
//                     <span>Platform Fee</span>
//                   </div>
//                   <span className="font-mono text-red-600">- ₹{totalPlatformFee.toFixed(2)}</span>
//                 </div>

//                 <div className="flex justify-between">
//                   <div className="flex items-center">
//                     <span>GST on Platform Fee (18%)</span>
//                   </div>
//                   <span className="font-mono text-red-600">- ₹{totalGST.toFixed(2)}</span>
//                 </div>

//                 <div className="flex justify-between">
//                   <div className="flex items-center">
//                     <span>Payment Gateway Charges</span>
//                   </div>
//                   <span className="font-mono text-red-600">- ₹{totalGatewayCharges.toFixed(2)}</span>
//                 </div>
//               </div>
//             </div>

//             <div className="flex justify-between pt-3 border-t-2 border-gray-300">
//               <span className="font-bold">Net Payable to Partners</span>
//               <span className="font-bold font-mono">₹{totalPayable.toFixed(2)}</span>
//             </div>

//             <div className="flex justify-between pt-2">
//               <span className="text-sm text-gray-600">Number of Beneficiaries</span>
//               <span className="text-sm font-mono">{numberOfBeneficiaries}</span>
//             </div>
//           </div>
//         </div>
//         {/* End Receipt Section */}








//         <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
//           <div className="bg-white p-4 rounded-md shadow-sm border">
//             <p className="text-sm text-gray-500">Total Payable</p>
//             {/* <p className="text-xl font-semibold">₹{totalPayable.toFixed(2)}</p> */}
//             <p className="text-xl font-semibold">₹{totalPayable}</p>
//           </div>
//           <div className="bg-white p-4 rounded-md shadow-sm border">
//             <p className="text-sm text-gray-500">Number of Beneficiaries</p>
//             <p className="text-xl font-semibold">{numberOfBeneficiaries}</p>
//           </div>
//           <div className="bg-white p-4 rounded-md shadow-sm border">
//             <p className="text-sm text-gray-500">Payment Status</p>
//             <p className="text-xl font-semibold">Pending</p>
//           </div>
//         </div>
//       </div>

//       <div className="mb-6">
//         <label className="block mb-2 text-sm font-medium text-gray-700">Payout Bank</label>
//         <select
//           value={selectedBank}
//           onChange={(e) => setSelectedBank(e.target.value)}
//           className="w-full p-2 border rounded-md mb-4"
//           disabled // Disabled since we only use Ujjivan Bank
//         >
//           <option value="Ujjivan Bank">Ujjivan Bank</option>
//         </select>

//         <div className="bg-blue-50 p-4 rounded-md">
//           <h4 className="font-medium mb-2">Payout File Details</h4>
//           <p className="text-sm text-gray-600 mb-2">
//             The generated file will contain only matched transactions in Ujjivan Bank's required format.
//           </p>
//           <p className="text-sm text-gray-600">
//             <strong>Note:</strong> Only transactions with status "Matched" will be included in the payout file.
//           </p>
//         </div>
//       </div>

//       <div className="mb-6">
//         <h4 className="font-medium mb-2">Matched Transactions to be Paid</h4>
//         <div className="overflow-x-auto">
//           <table className="min-w-full divide-y divide-gray-200">
//             <thead className="bg-gray-50">
//               <tr>
//                 <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Service</th>
//                 <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Invoice</th>
//                 <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
//                 <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Payable</th>
//                 <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Bank</th>
//               </tr>
//             </thead>
//             <tbody className="bg-white divide-y divide-gray-200">
//               {matchedEntries.map((entry, index) => (
//                 <tr key={index} className="hover:bg-gray-50">
//                   <td className="px-4 py-3 whitespace-nowrap">
//                     <span className={`px-2 py-1 text-xs rounded-full ${
//                       entry.serviceType === 'taxi' ? 'bg-blue-100 text-blue-800' : 'bg-purple-100 text-purple-800'
//                     }`}>
//                       {entry.serviceType}
//                     </span>
//                   </td>
//                   <td className="px-4 py-3 whitespace-nowrap">
//                     {entry.invoiceNumber || 'N/A'}
//                   </td>
//                   <td className="px-4 py-3 whitespace-nowrap">
//                     ₹{entry.customerAmount.toFixed(2)}
//                   </td>
//                   <td className="px-4 py-3 whitespace-nowrap">
//                     ₹{entry.payableToPartner.toFixed(2)}
//                   </td>
//                   <td className="px-4 py-3 whitespace-nowrap">
//                     {entry.serviceType === 'taxi' ? 
//                       (entry.riderBankDetails?.bankName || 'N/A') : 
//                       (entry.theaterBankDetails?.bankName || 'N/A')}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       <div className="flex justify-between">
//         <button
//           onClick={onBack}
//           className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400"
//         >
//           Back
//         </button>
//         <button
//           onClick={handleGenerate}
//           disabled={isGenerating || numberOfBeneficiaries === 0}
//           className={`px-4 py-2 rounded-md text-white ${
//             isGenerating || numberOfBeneficiaries === 0 ? 'bg-blue-400' : 'bg-blue-600 hover:bg-blue-700'
//           }`}
//         >
//           {isGenerating ? 'Generating...' : 'Generate Payout File'}
//         </button>
//       </div>
//     </div>
//   );
// };


// const Step4 = ({ onBack, reportData, generatePayoutFile }) => {
//   const [selectedBank, setSelectedBank] = useState('Ujjivan Bank');
//   const [isGenerating, setIsGenerating] = useState(false);

//   const matchedEntries = reportData?.summary?.detailedEntries?.filter(entry => entry.status === 'Matched') || [];

//   // Basic totals - using summary data first, fallback to calculations
//   const totalPayable = reportData?.summary?.totalPayableToPartners ||
//     matchedEntries.reduce((sum, entry) => sum + entry.payableToPartner, 0);
//   const numberOfBeneficiaries = matchedEntries.length;

//   // Detailed breakdown - using summary data first
//   const totalCollected = reportData?.summary?.totalCollections ||
//     matchedEntries.reduce((sum, entry) => sum + entry.customerAmount, 0);
//   const totalPlatformFee = reportData?.summary?.totalPlatformEarnings ||
//     matchedEntries.reduce((sum, entry) => sum + (entry.platformEarnings || 0), 0);
//   const totalGST = matchedEntries.reduce((sum, entry) => sum + (entry.platformTax || 0), 0); // Still calculated
//   const totalGatewayCharges = reportData?.summary?.totalGatewayCharges ||
//     matchedEntries.reduce((sum, entry) => sum + (entry.gatewayCharges || 0), 0);

//   // Theater specific amounts - names kept same
//   const totalTheaterPayable = totalPayable; // Aligned with totalPayable
//   const totalTheaterBase = matchedEntries.reduce((sum, entry) => sum + (entry.baseAmount || 0), 0);
//   const totalTheaterTax = reportData?.summary?.totalTaxes ||
//     matchedEntries.reduce((sum, entry) => sum + (entry.taxes || 0), 0);
//   const totalTheaterGateway = totalGatewayCharges; // Same as gateway charges
//   const totalTheaterPlatformFee = totalPlatformFee; // Same as platform fee
//   const totalTheaterPlatformTax = totalGST; // Same as GST (platformTax)

//   // Cash transactions (unchanged)
//   const cashEntries = matchedEntries.filter(entry => entry.paymentMethod === 'cash');
//   const cashTransactions = cashEntries.reduce((sum, entry) => sum + entry.customerAmount, 0);

//   // Amount calculations (unchanged logic, using the now-correct values)
//   const amountAfterCash = totalCollected - cashTransactions;
//   const amountAfterDeductions = amountAfterCash - totalGatewayCharges - totalPlatformFee - totalGST;
//   const tcsAmount = amountAfterDeductions * 0.02;
//   const finalPayableAmount = amountAfterDeductions - tcsAmount;

//   // Date range (unchanged)
//   const startDate = reportData?.periodStart ? new Date(reportData.periodStart).toLocaleDateString() : '7.5.2025';
//   const endDate = reportData?.periodEnd ? new Date(reportData.periodEnd).toLocaleDateString() : '10.6.2025';

//   // Function to handle receipt download
//   const downloadReceipt = () => {
//     const paymentMethods = cashTransactions > 0 ? 'Cash & UPI/PhonePe' : 'UPI/PhonePe';

//     const receiptHTML = `
//       <html>
//         <head>
//           <title>Payment Receipt</title>
//           <style>
//             body { font-family: Arial, sans-serif; margin: 20px; }
//             .receipt { max-width: 700px; margin: 0 auto; border: 1px solid #ddd; padding: 20px; }
//             .header { text-align: center; margin-bottom: 20px; border-bottom: 1px solid #ddd; padding-bottom: 10px; }
//             .summary { margin-bottom: 20px; }
//             .row { display: flex; justify-content: space-between; margin-bottom: 8px; }
//             .total-row { border-top: 1px solid #000; padding-top: 10px; margin-top: 10px; font-weight: bold; }
//             .double-line { border-top: 3px double #000; margin-top: 5px; padding-top: 10px; }
//             .negative { color: #e53e3e; }
//             .indent { padding-left: 20px; }
//             .text-right { text-align: right; }
//             .company-header { margin-bottom: 15px; }
//             .section-title { font-weight: bold; margin-top: 15px; }
//           </style>
//         </head>
//         <body>
//           <div class="receipt">
//             <div class="header">
//               <div class="company-header">
//                 <h2>Cruze-WMD Services India Pvt Ltd.</h2>
//                 <p>Payment Receipt</p>
//               </div>
//               <p>Date: ${new Date().toLocaleDateString()}</p>
//               <p>Period: ${startDate} to ${endDate}</p>
//             </div>
            
//             <div class="summary">
//               <div class="section-title">JSW Payment Summary</div>
//               <div class="row">
//                 <span>Total Transactions Amount (${paymentMethods}) collected for Movie Tickets from ${startDate} to ${endDate}</span>
//                 <span>₹${totalCollected.toFixed(2)}</span>
//               </div>
              
//               ${cashTransactions > 0 ? `
//                 <div class="row indent">
//                   <span>Tickets purchased & paid by Cash</span>
//                   <span class="negative">- ₹${cashTransactions.toFixed(2)}</span>
//                 </div>
//               ` : ''}
              
//               <div class="row ${cashTransactions > 0 ? 'indent' : ''}">
//                 <span>Payment Gateway Charge deductions</span>
//                 <span class="negative">- ₹${totalGatewayCharges.toFixed(2)}</span>
//               </div>
              
//               <div class="row ${cashTransactions > 0 ? 'indent' : ''}">
//                 <span>Platform fee deductions</span>
//                 <span class="negative">- ₹${totalPlatformFee.toFixed(2)}</span>
//               </div>
              
//               <div class="row ${cashTransactions > 0 ? 'indent' : ''}">
//                 <span>Platform fee - GST</span>
//                 <span class="negative">- ₹${totalGST.toFixed(2)}</span>
//               </div>
              
//               <div class="row total-row">
//                 <span>Total Amount after ${cashTransactions > 0 ? 'deducting cash transactions, ' : ''}Payment Gateway charges & Platform Fee/GST</span>
//                 <span>₹${amountAfterDeductions.toFixed(2)}</span>
//               </div>
              
//               <div class="row">
//                 <span>Tax collection at source by Cruze-WMD Services India Pvt Ltd. - TCS - 2%</span>
//                 <span class="negative">- ₹${tcsAmount.toFixed(2)}</span>
//               </div>
              
//               <div class="row total-row double-line">
//                 <span>Total Amount with GST to be paid to JSW for tickets period ${startDate} - ${endDate}</span>
//                 <span>₹${finalPayableAmount.toFixed(2)}</span>
//               </div>
              
//               <div class="section-title">Theater Payment Breakdown</div>
//               <div class="row">
//                 <span>Total payable to theater(s)</span>
//                 <span>₹${totalTheaterPayable.toFixed(2)}</span>
//               </div>
//               <div class="row indent">
//                 <span>Base amount</span>
//                 <span>₹${totalTheaterBase.toFixed(2)}</span>
//               </div>
//               <div class="row indent">
//                 <span>Tax on base amount</span>
//                 <span>₹${totalTheaterTax.toFixed(2)}</span>
//               </div>
//               <div class="row indent">
//                 <span>Gateway charges</span>
//                 <span>₹${totalTheaterGateway.toFixed(2)}</span>
//               </div>
//               <div class="row indent">
//                 <span>Platform fee</span>
//                 <span>₹${totalTheaterPlatformFee.toFixed(2)}</span>
//               </div>
//               <div class="row indent">
//                 <span>Platform tax</span>
//                 <span>₹${totalTheaterPlatformTax.toFixed(2)}</span>
//               </div>
//             </div>
//           </div>
//         </body>
//       </html>
//     `;

//     // Create a blob and download it
//     const blob = new Blob([receiptHTML], { type: 'text/html' });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = `JSW_Payment_Receipt_${startDate}_to_${endDate}.html`;
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     URL.revokeObjectURL(url);
//   };

//   const handleGenerate = () => {
//     if (!selectedBank) {
//       alert("Please select a bank.");
//       return;
//     }
//     setIsGenerating(true);

//     const payoutData = {
//       ...reportData,
//       summary: {
//         ...reportData.summary,
//         detailedEntries: matchedEntries
//       }
//     };

//     generatePayoutFile(selectedBank, payoutData);
//     setIsGenerating(false);
//   };

//   // Determine payment methods text
//   const paymentMethodsText = cashTransactions > 0
//     ? 'Cash & UPI/PhonePe'
//     : 'UPI/PhonePe';

//   return (
//     <div>
//       <h2 className="text-xl font-semibold mb-4">Step 4: Generate Payment Receipt</h2>

//       <div className="mb-6 bg-gray-50 p-4 rounded-md">
//         <h3 className="font-medium mb-2">Payment Summary (Matched Entries Only)</h3>

//         {/* Detailed Receipt Section */}
//         <div className="mb-6 bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
//           <div className="flex justify-between items-center mb-4">
//             <div>
//               <h4 className="text-lg font-medium">Cruze-WMD Services India Pvt Ltd.</h4>
//               <p className="text-sm text-gray-600">Payment Receipt</p>
//             </div>
//             <button
//               onClick={downloadReceipt}
//               className="px-3 py-1 bg-blue-100 text-blue-700 rounded-md text-sm hover:bg-blue-200"
//             >
//               Download Receipt
//             </button>
//           </div>

//           <div className="text-sm space-y-2">
//             <div className="flex justify-between">
//               <span className="text-gray-700">Period:</span>
//               <span>{startDate} to {endDate}</span>
//             </div>

//             <div className="mt-4 space-y-3">
//               <h5 className="font-medium">JSW Payment Summary</h5>
//               <div className="flex justify-between">
//                 <span>Total Transactions Amount ({paymentMethodsText}) collected for Movie Tickets</span>
//                 <span className="font-mono">₹{totalCollected.toFixed(2)}</span>
//               </div>

//               {cashTransactions > 0 && (
//                 <div className="flex justify-between pl-4">
//                   <span>Tickets purchased & paid by Cash</span>
//                   <span className="font-mono text-red-600">- ₹{cashTransactions.toFixed(2)}</span>
//                 </div>
//               )}

//               <div className={`flex justify-between ${cashTransactions > 0 ? 'pl-4' : ''}`}>
//                 <span>Payment Gateway Charge deductions</span>
//                 <span className="font-mono text-red-600">- ₹{totalGatewayCharges.toFixed(2)}</span>
//               </div>

//               <div className={`flex justify-between ${cashTransactions > 0 ? 'pl-4' : ''}`}>
//                 <span>Platform fee deductions</span>
//                 <span className="font-mono text-red-600">- ₹{totalPlatformFee.toFixed(2)}</span>
//               </div>

//               <div className={`flex justify-between ${cashTransactions > 0 ? 'pl-4' : ''}`}>
//                 <span>Platform fee - GST</span>
//                 <span className="font-mono text-red-600">- ₹{totalGST.toFixed(2)}</span>
//               </div>

//               <div className="flex justify-between pt-2 border-t border-gray-300">
//                 <span className="font-medium">
//                   Total Amount after {cashTransactions > 0 ? 'deducting cash transactions, ' : ''}all deductions
//                 </span>
//                 <span className="font-medium font-mono">₹{amountAfterDeductions.toFixed(2)}</span>
//               </div>

//               <div className="flex justify-between">
//                 <span>Tax collection at source (TCS - 2%)</span>
//                 <span className="font-mono text-red-600">- ₹{tcsAmount.toFixed(2)}</span>
//               </div>

//               <div className="flex justify-between pt-2 border-t-2 border-gray-400">
//                 <span className="font-bold">Total Amount payable to JSW</span>
//                 <span className="font-bold font-mono">₹{finalPayableAmount.toFixed(2)}</span>
//               </div>

//               <h5 className="font-medium mt-4">Theater Payment Breakdown</h5>
//               <div className="flex justify-between">
//                 <span>Total payable to theater(s)</span>
//                 <span className="font-mono">₹{totalTheaterPayable.toFixed(2)}</span>
//               </div>
//               <div className="flex justify-between pl-4">
//                 <span>Base amount</span>
//                 <span className="font-mono">₹{totalTheaterBase.toFixed(2)}</span>
//               </div>
//               <div className="flex justify-between pl-4">
//                 <span>Tax on base amount</span>
//                 <span className="font-mono">₹{totalTheaterTax.toFixed(2)}</span>
//               </div>
//               <div className="flex justify-between pl-4">
//                 <span>Gateway charges</span>
//                 <span className="font-mono">₹{totalTheaterGateway.toFixed(2)}</span>
//               </div>
//               <div className="flex justify-between pl-4">
//                 <span>Platform fee</span>
//                 <span className="font-mono">₹{totalTheaterPlatformFee.toFixed(2)}</span>
//               </div>
//               <div className="flex justify-between pl-4">
//                 <span>Platform tax</span>
//                 <span className="font-mono">₹{totalTheaterPlatformTax.toFixed(2)}</span>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
//           <div className="bg-white p-4 rounded-md shadow-sm border">
//             <p className="text-sm text-gray-500">Total Payable to JSW</p>
//             <p className="text-xl font-semibold">₹{finalPayableAmount.toFixed(2)}</p>
//           </div>
//           <div className="bg-white p-4 rounded-md shadow-sm border">
//             <p className="text-sm text-gray-500">Total Payable to Theaters</p>
//             <p className="text-xl font-semibold">₹{totalTheaterPayable.toFixed(2)}</p>
//           </div>
//           <div className="bg-white p-4 rounded-md shadow-sm border">
//             <p className="text-sm text-gray-500">Number of Transactions</p>
//             <p className="text-xl font-semibold">{numberOfBeneficiaries}</p>
//           </div>
//         </div>
//       </div>

//       <div className="mb-6">
//         <label className="block mb-2 text-sm font-medium text-gray-700">Payout Bank</label>
//         <select
//           value={selectedBank}
//           onChange={(e) => setSelectedBank(e.target.value)}
//           className="w-full p-2 border rounded-md mb-4"
//           disabled
//         >
//           <option value="Ujjivan Bank">Ujjivan Bank</option>
//         </select>

//         <div className="bg-blue-50 p-4 rounded-md">
//           <h4 className="font-medium mb-2">Payout File Details</h4>
//           <p className="text-sm text-gray-600 mb-2">
//             The generated file will contain only matched transactions in Ujjivan Bank's required format.
//           </p>
//           <p className="text-sm text-gray-600">
//             <strong>Note:</strong> Only transactions with status "Matched" will be included in the payout file.
//           </p>
//         </div>
//       </div>

//       <div className="flex justify-between">
//         <button
//           onClick={onBack}
//           className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400"
//         >
//           Back
//         </button>
//         <button
//           onClick={handleGenerate}
//           disabled={isGenerating || numberOfBeneficiaries === 0}
//           className={`px-4 py-2 rounded-md text-white ${isGenerating || numberOfBeneficiaries === 0 ? 'bg-blue-400' : 'bg-blue-600 hover:bg-blue-700'
//             }`}
//         >
//           {isGenerating ? 'Generating...' : 'Generate Payout File'}
//         </button>
//       </div>
//     </div>
//   );
// };

// Just matched entry
const Step4 = ({ onBack, reportData, generatePayoutFile }) => {
  const [selectedBank, setSelectedBank] = useState('Ujjivan Bank');
  const [isGenerating, setIsGenerating] = useState(false);

  // Filter only matched entries
  const matchedEntries = reportData?.summary?.detailedEntries?.filter(entry => entry.status === 'Matched') || [];

  // Calculate totals from matched entries only
  const calculateMatchedTotals = () => {
    return {
      totalPayable: matchedEntries.reduce((sum, entry) => sum + entry.payableToPartner, 0),
      totalCollected: matchedEntries.reduce((sum, entry) => sum + entry.customerAmount, 0),
      totalPlatformFee: matchedEntries.reduce((sum, entry) => sum + (entry.platformEarnings || 0), 0),
      totalGST: matchedEntries.reduce((sum, entry) => sum + (entry.platformTax || 0), 0),
      totalGatewayCharges: matchedEntries.reduce((sum, entry) => sum + (entry.gatewayCharges || 0), 0),
      totalTheaterBase: matchedEntries.reduce((sum, entry) => sum + (entry.baseAmount || 0), 0),
      totalTheaterTax: matchedEntries.reduce((sum, entry) => sum + (entry.taxes || 0), 0),
    };
  };

  const {
    totalPayable,
    totalCollected,
    totalPlatformFee,
    totalGST,
    totalGatewayCharges,
    totalTheaterBase,
    totalTheaterTax
  } = calculateMatchedTotals();

  const numberOfBeneficiaries = matchedEntries.length;

  // Cash transactions
  const cashEntries = matchedEntries.filter(entry => entry.paymentMethod === 'cash');
  const cashTransactions = cashEntries.reduce((sum, entry) => sum + entry.customerAmount, 0);

  // Amount calculations
  const amountAfterCash = totalCollected - cashTransactions;
  const amountAfterDeductions = amountAfterCash - totalGatewayCharges - totalPlatformFee - totalGST;
  const tcsAmount = amountAfterDeductions * 0.02;
  const finalPayableAmount = amountAfterDeductions - tcsAmount;

  // Date range
  const startDate = reportData?.periodStart ? new Date(reportData.periodStart).toLocaleDateString() : 'N/A';
  const endDate = reportData?.periodEnd ? new Date(reportData.periodEnd).toLocaleDateString() : 'N/A';

  const downloadReceipt = () => {
    const paymentMethods = cashTransactions > 0 ? 'Cash & UPI/PhonePe' : 'UPI/PhonePe';

    const receiptHTML = `
      <html>
        <head>
          <title>Payment Receipt</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            .receipt { max-width: 700px; margin: 0 auto; border: 1px solid #ddd; padding: 20px; }
            .header { text-align: center; margin-bottom: 20px; border-bottom: 1px solid #ddd; padding-bottom: 10px; }
            .summary { margin-bottom: 20px; }
            .row { display: flex; justify-content: space-between; margin-bottom: 8px; }
            .total-row { border-top: 1px solid #000; padding-top: 10px; margin-top: 10px; font-weight: bold; }
            .double-line { border-top: 3px double #000; margin-top: 5px; padding-top: 10px; }
            .negative { color: #e53e3e; }
            .indent { padding-left: 20px; }
            .text-right { text-align: right; }
            .company-header { margin-bottom: 15px; }
            .section-title { font-weight: bold; margin-top: 15px; }
          </style>
        </head>
        <body>
          <div class="receipt">
            <div class="header">
              <div class="company-header">
                <h2>Cruze-WMD Services India Pvt Ltd.</h2>
                <p>Matched Transactions Payment Receipt</p>
              </div>
              <p>Date: ${new Date().toLocaleDateString()}</p>
              <p>Period: ${startDate} to ${endDate}</p>
              <p>Matched Transactions: ${numberOfBeneficiaries}</p>
            </div>
            
            <div class="summary">
              <div class="section-title">JSW Payment Summary</div>
              <div class="row">
                <span>Total Matched Transactions Amount (${paymentMethods})</span>
                <span>₹${totalCollected.toFixed(2)}</span>
              </div>
              
              ${cashTransactions > 0 ? `
                <div class="row indent">
                  <span>Tickets purchased & paid by Cash</span>
                  <span class="negative">- ₹${cashTransactions.toFixed(2)}</span>
                </div>
              ` : ''}
              
              <div class="row ${cashTransactions > 0 ? 'indent' : ''}">
                <span>Payment Gateway Charge deductions</span>
                <span class="negative">- ₹${totalGatewayCharges.toFixed(2)}</span>
              </div>
              
              <div class="row ${cashTransactions > 0 ? 'indent' : ''}">
                <span>Platform fee deductions</span>
                <span class="negative">- ₹${totalPlatformFee.toFixed(2)}</span>
              </div>
              
              <div class="row ${cashTransactions > 0 ? 'indent' : ''}">
                <span>Platform fee - GST</span>
                <span class="negative">- ₹${totalGST.toFixed(2)}</span>
              </div>
              
              <div class="row total-row">
                <span>Total Amount after ${cashTransactions > 0 ? 'deducting cash transactions, ' : ''}all deductions</span>
                <span>₹${amountAfterDeductions.toFixed(2)}</span>
              </div>
              
              <div class="row">
                <span>Tax collection at source (TCS - 2%)</span>
                <span class="negative">- ₹${tcsAmount.toFixed(2)}</span>
              </div>
              
              <div class="row total-row double-line">
                <span>Total Amount payable to JSW</span>
                <span>₹${finalPayableAmount.toFixed(2)}</span>
              </div>
              
              <div class="section-title">Theater Payment Breakdown</div>
              <div class="row">
                <span>Total payable to theater(s)</span>
                <span>₹${totalPayable.toFixed(2)}</span>
              </div>
              <div class="row indent">
                <span>Base amount</span>
                <span>₹${totalTheaterBase.toFixed(2)}</span>
              </div>
              <div class="row indent">
                <span>Tax on base amount</span>
                <span>₹${totalTheaterTax.toFixed(2)}</span>
              </div>
              <div class="row indent">
                <span>Gateway charges</span>
                <span>₹${totalGatewayCharges.toFixed(2)}</span>
              </div>
              <div class="row indent">
                <span>Platform fee</span>
                <span>₹${totalPlatformFee.toFixed(2)}</span>
              </div>
              <div class="row indent">
                <span>Platform tax</span>
                <span>₹${totalGST.toFixed(2)}</span>
              </div>
            </div>
          </div>
        </body>
      </html>
    `;

    const blob = new Blob([receiptHTML], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `JSW_Payment_Receipt_Matched_${startDate}_to_${endDate}.html`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleGenerate = () => {
    if (!selectedBank) {
      alert("Please select a bank.");
      return;
    }
    setIsGenerating(true);

    const payoutData = {
      ...reportData,
      summary: {
        ...reportData.summary,
        detailedEntries: matchedEntries
      }
    };

    generatePayoutFile(selectedBank, payoutData);
    setIsGenerating(false);
  };

  const paymentMethodsText = cashTransactions > 0 ? 'Cash & UPI/PhonePe' : 'UPI/PhonePe';

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Step 4: Generate Payment Receipt (Matched Only)</h2>

      {numberOfBeneficiaries === 0 && (
        <div className="mb-4 p-3 bg-yellow-100 text-yellow-800 rounded-md">
          Warning: No matched transactions found. Payout file will be empty.
        </div>
      )}

      <div className="mb-4 flex items-center">
        <span className="bg-green-100 text-green-800 text-sm font-medium px-3 py-1 rounded-full">
          {numberOfBeneficiaries} Matched Transactions
        </span>
        {reportData?.summary?.detailedEntries?.length > numberOfBeneficiaries && (
          <span className="ml-2 text-sm text-gray-500">
            ({reportData.summary.detailedEntries.length - numberOfBeneficiaries} unmatched transactions excluded)
          </span>
        )}
      </div>

      <div className="mb-6 bg-gray-50 p-4 rounded-md">
        <h3 className="font-medium mb-2">Matched Transactions Payment Summary</h3>

        <div className="mb-6 bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
          <div className="flex justify-between items-center mb-4">
            <div>
              <h4 className="text-lg font-medium">Cruze-WMD Services India Pvt Ltd.</h4>
              <p className="text-sm text-gray-600">Matched Transactions Receipt</p>
            </div>
            <button
              onClick={downloadReceipt}
              className="px-3 py-1 bg-blue-100 text-blue-700 rounded-md text-sm hover:bg-blue-200"
            >
              Download Receipt
            </button>
          </div>

          <div className="text-sm space-y-2">
            <div className="flex justify-between">
              <span className="text-gray-700">Period:</span>
              <span>{startDate} to {endDate}</span>
            </div>

            <div className="mt-4 space-y-3">
              <h5 className="font-medium">JSW Payment Summary</h5>
              <div className="flex justify-between">
                <span>Total Matched Transactions Amount ({paymentMethodsText})</span>
                <span className="font-mono">₹{totalCollected.toFixed(2)}</span>
              </div>

              {cashTransactions > 0 && (
                <div className="flex justify-between pl-4">
                  <span>Tickets purchased & paid by Cash</span>
                  <span className="font-mono text-red-600">- ₹{cashTransactions.toFixed(2)}</span>
                </div>
              )}

              <div className={`flex justify-between ${cashTransactions > 0 ? 'pl-4' : ''}`}>
                <span>Payment Gateway Charge deductions</span>
                <span className="font-mono text-red-600">- ₹{totalGatewayCharges.toFixed(2)}</span>
              </div>

              <div className={`flex justify-between ${cashTransactions > 0 ? 'pl-4' : ''}`}>
                <span>Platform fee deductions</span>
                <span className="font-mono text-red-600">- ₹{totalPlatformFee.toFixed(2)}</span>
              </div>

              <div className={`flex justify-between ${cashTransactions > 0 ? 'pl-4' : ''}`}>
                <span>Platform fee - GST</span>
                <span className="font-mono text-red-600">- ₹{totalGST.toFixed(2)}</span>
              </div>

              <div className="flex justify-between pt-2 border-t border-gray-300">
                <span className="font-medium">
                  Total Amount after {cashTransactions > 0 ? 'deducting cash transactions, ' : ''}all deductions
                </span>
                <span className="font-medium font-mono">₹{amountAfterDeductions.toFixed(2)}</span>
              </div>

              <div className="flex justify-between">
                <span>Tax collection at source (TCS - 2%)</span>
                <span className="font-mono text-red-600">- ₹{tcsAmount.toFixed(2)}</span>
              </div>

              <div className="flex justify-between pt-2 border-t-2 border-gray-400">
                <span className="font-bold">Total Amount payable to JSW</span>
                <span className="font-bold font-mono">₹{finalPayableAmount.toFixed(2)}</span>
              </div>

              <h5 className="font-medium mt-4">Theater Payment Breakdown</h5>
              <div className="flex justify-between">
                <span>Total payable to theater(s)</span>
                <span className="font-mono">₹{totalPayable.toFixed(2)}</span>
              </div>
              <div className="flex justify-between pl-4">
                <span>Base amount</span>
                <span className="font-mono">₹{totalTheaterBase.toFixed(2)}</span>
              </div>
              <div className="flex justify-between pl-4">
                <span>Tax on base amount</span>
                <span className="font-mono">₹{totalTheaterTax.toFixed(2)}</span>
              </div>
              <div className="flex justify-between pl-4">
                <span>Gateway charges</span>
                <span className="font-mono">₹{totalGatewayCharges.toFixed(2)}</span>
              </div>
              <div className="flex justify-between pl-4">
                <span>Platform fee</span>
                <span className="font-mono">₹{totalPlatformFee.toFixed(2)}</span>
              </div>
              <div className="flex justify-between pl-4">
                <span>Platform tax</span>
                <span className="font-mono">₹{totalGST.toFixed(2)}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <div className="bg-white p-4 rounded-md shadow-sm border">
            <p className="text-sm text-gray-500">Total Payable to JSW</p>
            <p className="text-xl font-semibold">₹{finalPayableAmount.toFixed(2)}</p>
          </div>
          <div className="bg-white p-4 rounded-md shadow-sm border">
            <p className="text-sm text-gray-500">Total Payable to Theaters</p>
            <p className="text-xl font-semibold">₹{totalPayable.toFixed(2)}</p>
          </div>
          <div className="bg-white p-4 rounded-md shadow-sm border">
            <p className="text-sm text-gray-500">Matched Transactions</p>
            <p className="text-xl font-semibold">{numberOfBeneficiaries}</p>
          </div>
        </div>
      </div>

      <div className="mb-6">
        <label className="block mb-2 text-sm font-medium text-gray-700">Payout Bank</label>
        <select
          value={selectedBank}
          onChange={(e) => setSelectedBank(e.target.value)}
          className="w-full p-2 border rounded-md mb-4"
          disabled
        >
          <option value="Ujjivan Bank">Ujjivan Bank</option>
        </select>

        <div className="bg-blue-50 p-4 rounded-md">
          <h4 className="font-medium mb-2">Payout File Details</h4>
          <p className="text-sm text-gray-600 mb-2">
            The payout file will contain {numberOfBeneficiaries} matched transactions in Ujjivan Bank's required format.
          </p>
          <p className="text-sm text-gray-600">
            <strong>Note:</strong> Only transactions with "Matched" status are included. All others are excluded.
          </p>
        </div>
      </div>

      <div className="flex justify-between">
        <button
          onClick={onBack}
          className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400"
        >
          Back
        </button>
        <button
          onClick={handleGenerate}
          disabled={isGenerating || numberOfBeneficiaries === 0}
          className={`px-4 py-2 rounded-md text-white ${isGenerating || numberOfBeneficiaries === 0 ? 'bg-blue-400' : 'bg-blue-600 hover:bg-blue-700'}`}
        >
          {isGenerating ? 'Generating...' : 'Generate Payout File'}
        </button>
      </div>
    </div>
  );
};









export default Payment;
